/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Shared_PictureResolutions {
    Small = 10,
    Medium = 20,
    Large = 30,
}
